// extracted by mini-css-extract-plugin
export default {"zoomModal":"T0-z","image":"U0-z","button":"V0-z","isOverlayShown":"W0-z"};